import type { App } from '@grafikr/components';

import Cart from 'utils/cart';

export default ({ context }: App) => {
  const getCart = async () => {
    const { data } = await Cart.get();

    if (data) {
      theme.cart = data;
      context.dispatchEvent('cart:fetched', data);
    }
  };

  document.addEventListener('cart:added', getCart);
  document.addEventListener('cart:updated', getCart);
};
